export enum EmojiType {
  VERY_BAD = 'VERY_BAD',
  BAD = 'BAD',
  SATISFIED = 'SATISFIED',
  GOOD = 'GOOD',
  VERY_GOOD = 'VERY_GOOD',
}
